import React from 'react';

import { AutocompleteAddressInput } from 'components/autocomplete-address-input';
import { useGeolocation } from 'state/geolocation';
import { t } from 'state/intl/translations';
import { isWeb } from 'utils/environment';

import { ISearchBarProps } from './types';

export const SearchBar = ({
  defaultValue,
  onAddressSelected,
  coverSuggestionTouches,
}: ISearchBarProps) => {
  const { resetCoordinatesManual, setManualAddress, manualAddress } = useGeolocation();

  return (
    <AutocompleteAddressInput
      required
      value={manualAddress || defaultValue}
      onInputValueChange={value => {
        setManualAddress(value?.toString() || '');
        if (!value) {
          resetCoordinatesManual();
        }
      }}
      onAddressSelected={(address, placeId, placeData) =>
        onAddressSelected?.(address, placeId, placeData)
      }
      label={t('yourAddress')}
      testID="storelocator-autocomplete"
      inputCustomProps={{ backgroundColor: 'white' }}
      disableBrowserAutofill={isWeb}
      coverSuggestionTouches={coverSuggestionTouches}
    />
  );
};
